// extracted by mini-css-extract-plugin
export default {"image":"image_sJ7bk"};